"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../Box/index.js");
var _SlotSizes = require("./SlotSizes.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _index2 = require("../../styles/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Box = exports.Box = (0, _styledComponents["default"])(_index.Box).withConfig({
  displayName: "Box",
  componentId: "sc-1njtxi4-0"
})(["", ""], function (_ref) {
  var $contentAlign = _ref.$contentAlign,
    $verticalGap = _ref.$verticalGap,
    $size = _ref.$size;
  return (0, _styledComponents.css)(["display:inline-flex;flex-direction:column;row-gap:", ";&[disabled]{opacity:", ";}", ""], (0, _index2.isSpacer)($verticalGap) ? (0, _index2.cssSpacing)($verticalGap) : $verticalGap, _encoreFoundation.opacity70, $contentAlign && (0, _styledComponents.css)(["margin-inline:calc(-1 * ", ");"], _SlotSizes.padding[$size]));
});